import { Link } from "react-router-dom";
import { categories } from "@/mocks/events";
import { siteInfo } from "@/mocks/site";

export default function SiteFooter() {
  const year = new Date().getFullYear();
  return (
    <footer className="mt-20 bg-primary-900 text-background-100">
      <div className="max-w-shell mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="w-9 h-9 rounded-md bg-accent-500 text-primary-950 flex items-center justify-center font-heading font-black text-lg">
                爆
              </span>
              <span className="font-heading text-lg font-bold tracking-wide text-background-50">
                {siteInfo.name}
              </span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-200/85 max-w-md">
              {siteInfo.description}
            </p>
            <a
              href={`mailto:${siteInfo.contactEmail}`}
              rel="nofollow"
              className="mt-5 inline-flex items-center gap-2 text-sm text-accent-300 hover:text-accent-200 transition-colors cursor-pointer"
            >
              <i className="ri-mail-send-line" />
              {siteInfo.contactEmail}
            </a>
            <p className="mt-2 text-xs text-background-300/75">{siteInfo.workingHours}</p>
          </div>

          <div className="md:col-span-3">
            <h3 className="text-sm font-medium text-background-50 tracking-widest">站内导航</h3>
            <ul className="mt-4 flex flex-col gap-2.5">
              <li>
                <Link to="/" className="text-sm text-background-200/85 hover:text-accent-300 transition-colors cursor-pointer">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/events" className="text-sm text-background-200/85 hover:text-accent-300 transition-colors cursor-pointer">
                  热点总览
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-200/85 hover:text-accent-300 transition-colors cursor-pointer">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-200/85 hover:text-accent-300 transition-colors cursor-pointer">
                  线索投递
                </Link>
              </li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <h3 className="text-sm font-medium text-background-50 tracking-widest">分类专题</h3>
            <div className="mt-4 flex flex-wrap gap-2">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/events?cat=${cat.slug}`}
                  className="px-3 py-1.5 rounded-full border border-primary-700 text-xs text-background-200/85 hover:border-accent-400 hover:text-accent-300 transition-colors cursor-pointer"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-primary-800 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-background-300/75">
            © {year} {siteInfo.name} · {siteInfo.icp}
          </p>
          <p className="text-xs text-background-300/75">
            站内信息以公开表述与可核查材料为准，时间线内容会随进展持续更新。
          </p>
        </div>
      </div>
    </footer>
  );
}